/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export function LiveIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d='M66.275 17.119a34.407 34.407 0 018.267 22.424c0 8.559-3.112 16.39-8.267 22.425-.978 1.145-.988 2.866.077 3.93 1.066 1.065 2.8 1.071 3.79-.064a39.845 39.845 0 009.854-26.29 39.846 39.846 0 00-9.853-26.292c-.991-1.134-2.725-1.129-3.79-.064-1.066 1.065-1.056 2.786-.078 3.93zM9.854 13.252A39.845 39.845 0 000 39.543a39.845 39.845 0 009.854 26.292c.99 1.134 2.725 1.128 3.79.063s1.055-2.785.077-3.93a34.407 34.407 0 01-8.267-22.424c0-8.559 3.113-16.39 8.267-22.425.978-1.145.988-2.865-.078-3.93-1.065-1.065-2.799-1.071-3.79.063z' />
      <path d='M58.64 58.185c1.064 1.065 2.802 1.072 3.763-.087a28.97 28.97 0 006.684-18.554 28.97 28.97 0 00-6.684-18.555c-.961-1.16-2.7-1.152-3.764-.087-1.065 1.065-1.05 2.783-.115 3.963a23.537 23.537 0 015.11 14.679c0 5.546-1.911 10.646-5.11 14.678-.936 1.18-.95 2.898.115 3.963zM10.909 39.544c0-7.053 2.51-13.519 6.684-18.555.961-1.16 2.699-1.152 3.764-.087s1.05 2.783.115 3.963a23.536 23.536 0 00-5.11 14.679c0 5.546 1.911 10.646 5.11 14.678.936 1.18.95 2.898-.115 3.963s-2.803 1.072-3.764-.087a28.971 28.971 0 01-6.684-18.554zM50.907 39.544c0 6.024-4.884 10.908-10.909 10.908S29.09 45.568 29.09 39.544c0-6.025 4.883-10.91 10.908-10.91 6.025 0 10.909 4.885 10.909 10.91z' />
    </SvgIcon>
  );
}

export function TicketOutlinedIcon() {
  return (
    <svg width='20' viewBox='0 0 192 192' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path d='M104 60C104 55.5817 107.582 52 112 52C116.418 52 120 55.5817 120 60V68C120 72.4183 116.418 76 112 76C107.582 76 104 72.4183 104 68V60Z'></path>
      <path d='M104 92C104 87.5817 107.582 84 112 84C116.418 84 120 87.5817 120 92V100C120 104.418 116.418 108 112 108C107.582 108 104 104.418 104 100V92Z'></path>
      <path d='M104 124C104 119.582 107.582 116 112 116C116.418 116 120 119.582 120 124V132C120 136.418 116.418 140 112 140C107.582 140 104 136.418 104 132V124Z'></path>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16.004 112C24.8317 111.991 31.9849 104.831 31.9849 96.0001C31.9849 87.1689 24.8307 80.0087 16.0021 80.0002L16 80.0002L16 40C16 35.5817 19.5814 32 23.9993 32L168.001 32C172.419 32 176 35.5817 176 40L176 80.0002C167.171 80.0076 160.015 87.1682 160.015 96.0001C160.015 104.832 167.171 111.993 176 112V152C176 156.418 172.419 160 168.001 160L23.9993 160C19.5814 160 16 156.418 16 152L16 112H16.004ZM164 148V121.299C154.548 116.802 148.015 107.164 148.015 96.0001C148.015 84.8367 154.548 75.1984 164 70.7015L164 44L28 44L28 70.7015C37.452 75.1984 43.9849 84.8367 43.9849 96.0001C43.9849 107.164 37.452 116.802 28 121.299L28 148L164 148Z'
      ></path>
    </svg>
  );
}

export function BuildingOutlinedIcon() {
  return (
    <svg width='20' viewBox='0 0 24 24'>
      <path d='M17 7h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zM1 11v10h6v-5h2v5h6V11L8 6l-7 5zm12 8h-2v-5H5v5H3v-7l5-3.5 5 3.5v7z'></path>
      <path d='M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z'></path>
    </svg>
  );
}

export function BarCodeIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d='M.833 3.958c0-.345.28-.625.625-.625h17.084a.625.625 0 110 1.25H1.458a.625.625 0 01-.625-.625zm0 12.084c0-.346.28-.625.625-.625h17.084a.625.625 0 110 1.25H1.458a.625.625 0 01-.625-.625z' />
      <path d='M17.916 6.667V3.958h1.25v2.709a.625.625 0 11-1.25 0zM.833 6.667V3.958h1.25v2.709a.625.625 0 11-1.25 0zM1.458 12.813c.345 0 .625.28.625.624v2.605H.833v-2.605c0-.345.28-.624.625-.624zM18.541 12.813c.346 0 .625.28.625.624v2.605h-1.25v-2.605c0-.345.28-.624.625-.624z' />
      <path d='M3.333 7.188c0-.115.094-.209.209-.209h1.25c.115 0 .208.094.208.209v5.52a.208.208 0 01-.208.209h-1.25a.208.208 0 01-.209-.209v-5.52zM9.166 7.188c0-.115.094-.209.209-.209h1.666c.116 0 .209.094.209.209v5.52a.208.208 0 01-.209.209H9.375a.208.208 0 01-.209-.209v-5.52zM5.833 7.083c0-.057.047-.104.104-.104h.625c.058 0 .105.047.105.104v5.73a.104.104 0 01-.105.104h-.625a.104.104 0 01-.104-.104v-5.73zM7.5 7.083c0-.057.047-.104.104-.104h.625c.058 0 .104.047.104.104v5.73a.104.104 0 01-.104.104h-.625a.104.104 0 01-.104-.104v-5.73zM12.083 7.083c0-.057.047-.104.104-.104h.625c.058 0 .105.047.105.104v5.73a.104.104 0 01-.105.104h-.625a.104.104 0 01-.104-.104v-5.73zM13.75 7.083c0-.057.047-.104.104-.104h.625c.058 0 .104.047.104.104v5.73a.104.104 0 01-.104.104h-.625a.104.104 0 01-.104-.104v-5.73zM15.416 7.188c0-.115.094-.209.209-.209h.833c.115 0 .209.094.209.209v5.52a.208.208 0 01-.209.209h-.833a.208.208 0 01-.209-.209v-5.52z' />
    </SvgIcon>
  );
}

export function TelegramIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d='M10 17.917a7.917 7.917 0 100-15.833 7.917 7.917 0 000 15.833zM19.167 10A9.167 9.167 0 11.833 10a9.167 9.167 0 0118.334 0z' />
      <path d='M8.124 13.688c.23 0 .33-.105.459-.23l1.222-1.188-1.525-.919' />
      <path d='M8.28 11.351l3.694 2.73c.422.232.726.112.831-.392l1.504-7.086c.154-.617-.236-.897-.639-.714L4.84 9.294c-.602.241-.599.578-.11.727l2.266.708 5.246-3.31c.248-.15.475-.07.289.096' />
    </SvgIcon>
  );
}

export function TransferIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <g clipPath='url(#clip0)' fillRule='evenodd' clipRule='evenodd'>
        <path d='M4.8 3.82c.63-.75 1.85-.31 1.85.66v1.56h6.56V7.3H5.4V5.06L2.67 8.34l2.73 3.3V9.38h8.15v1.26h-6.9v1.6c0 .97-1.23 1.41-1.85.66l-3.2-3.9a1.04 1.04 0 010-1.32l3.2-3.85z' />
        <path d='M16.2 7.15a1.04 1.04 0 00-1.85.67v1.55h-.96v1.25h2.21V8.4l2.73 3.28-2.73 3.3v-2.26H9.25a.63.63 0 000 1.25h5.1v1.6c0 .98 1.23 1.42 1.85.66l3.2-3.89c.33-.39.33-.94 0-1.33l-3.2-3.85z' />
      </g>
      <defs>
        <clipPath id='clip0'>
          <path d='M.5 0h20v20H.5V0z' />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export function CancelTransferIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.33 8.33a1.67 1.67 0 100 3.34v.52a4.38 4.38 0 00-6.95 4.48H3.32c-.92 0-1.66-.75-1.66-1.67v-3.33a1.67 1.67 0 000-3.34V5c0-.92.74-1.67 1.66-1.67h13.34c.92 0 1.66.75 1.66 1.67v3.33zm-7.5 4.56v-1.82c-2.31 0-3.84.7-5 2.26.47-2.22 1.76-4.44 5-4.89V6.67l3.34 3.1-3.34 3.12z'
        fill='#D81B60'
      />
      <g clipPath='url(#clip0)'>
        <path
          d='M15.63 12.15a3.47 3.47 0 100 6.95 3.47 3.47 0 003.47-3.48 3.47 3.47 0 00-3.48-3.47zm1.73 4.72l-.5.49-1.23-1.24-1.25 1.24-.5-.49 1.25-1.25-1.24-1.24.49-.5 1.24 1.25 1.25-1.24.5.49-1.25 1.24 1.24 1.25z'
          fill='#F44336'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <path fill='#fff' transform='translate(11.46 11.46)' d='M0 0h8.33v8.33H0z' />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export function DownloadIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <g clipPath='url(#clip0)'>
        <path
          fill='#000000'
          d='M8.57 10.3a1 1 0 00.2-.15l1.8-1.72a.5.5 0 11.67.71L8.7 11.57a1 1 0 01-1.38 0L4.9 9.26a.53.53 0 01.74-.78l1.74 1.67.17.13v-8.1a.5.5 0 111.02 0v8.12z'
        />
        <path
          fill='#000000'
          d='M1.67 8.17a.5.5 0 111 0v5.16h10.66V8.17a.5.5 0 111 0v5.66a.5.5 0 01-.5.5H2.17a.5.5 0 01-.5-.5V8.17z'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <path fill='#000000' d='M0 0h16v16H0V0z' />
        </clipPath>
      </defs>
      <g clipPath='url(#clip0)'>
        <path
          fill='#000000'
          d='M8.57 10.3a1 1 0 00.2-.15l1.8-1.72a.5.5 0 11.67.71L8.7 11.57a1 1 0 01-1.38 0L4.9 9.26a.53.53 0 01.74-.78l1.74 1.67.17.13v-8.1a.5.5 0 111.02 0v8.12z'
        />
        <path
          fill='#000000'
          d='M1.67 8.17a.5.5 0 111 0v5.16h10.66V8.17a.5.5 0 111 0v5.66a.5.5 0 01-.5.5H2.17a.5.5 0 01-.5-.5V8.17z'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <path fill='#000000' d='M0 0h16v16H0V0z' />
        </clipPath>
      </defs>
      v
    </SvgIcon>
  );
}
